/* ============================================================================
   UMAI BUNDLE — build-your-own pack, True Classic shape.

   Shape:  pick how many  ->  pick ONE size  ->  the slots fill themselves  ->
           tap any slot to change its colour  ->  one add.

   Why this shape and not the obvious one. The first version of this asked for a
   colour AND a size per shirt: twelve-plus decisions to assemble a six-pack,
   and it was rightly thrown out. The second went the other way — a single
   colour and size for the whole pack — which is simple but cannot express
   "2 black, 2 grey, 2 white", the single most natural way to buy blanks. It
   also contradicted the bag's own cross-sell, which adds one of each colour.

   So: ONE size for the whole pack (the decision people actually have an opinion
   about, and the same for every shirt when you are buying for yourself), and
   per-slot colour that is PRE-FILLED by rotating the colourways. The pack is
   complete the moment it appears — the fast path is choose size, add — and
   customising is a tap on the slot you want to change. Nobody is made to
   assemble anything.

   The tier quantity is the only thing the Shopify discount cares about: 3PACK
   and 6PACK are minimum-QUANTITY rules on the product, not per-variant, so any
   mix of three or six earns the price. That is what makes this safe to build.

   ⚠ PRICES HERE ARE DISPLAY ONLY. Tier totals are a Liquid constant at the top
   of sections/product-umai.liquid; the cart is discounted by a separate Shopify
   automatic discount (3PACK 1491795280006, 6PACK 1491795443846). If the two
   disagree the PDP quotes a price checkout will refuse. One change, not two.
   ========================================================================== */
(function () {
  'use strict';

  var I18N = window.UMAI_I18N || {};
  function tr(k, fb) { return I18N[k] || fb; }
  /* Placeholder form for anything mixing words with a number or a price.
     Concatenating ("Save " + money) only reads right in English — Japanese puts
     the amount first, Polish declines the noun after a count. */
  function trf(k, fb, vars) {
    var s = tr(k, fb);
    for (var p in vars) s = s.split('[' + p + ']').join(vars[p]);
    return s;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency) || {};
    var rate = parseFloat(cur.rate) || 1;
    var v = cents * rate;
    if (cur.active && cur.active !== 'USD') {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur.active }).format(v / 100); } catch (e) {}
    }
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return fmt.replace(/<[^>]+>/g, '').replace(/\{\{\s*amount[^}]*\}\}/, (v / 100).toFixed(2)).trim();
  }

  /* GA4 / Meta / Klaviyo, each guarded — a blocked pixel must never take the
     buy button down with it.

     2026-09-07 (Ryan) — the GA4 and Meta branches below have never reached
     anything. Google and Meta run on this store as Shopify Customer Events
     pixels, inside a sandboxed frame that cannot see this page's
     window.dataLayer or window.fbq (grep the served HTML: no googletagmanager,
     no gtag, no connect.facebook.net — the only fbq in the page is the guarded
     caller here). So dataLayer.push wrote to an array nobody reads and the fbq
     call never fired; only Klaviyo's _learnq shim was real.
     Shopify.analytics.publish is the ONE bridge from theme code into that
     sandbox, so it is added below. The two dead lines are kept rather than
     replaced: they cost nothing and they start working the day a GTM container
     or a real Meta pixel is put on the page directly.
     ⚠ HALF OF THIS FIX IS IN ADMIN. publish() is a no-op until a Custom Pixel
     (Settings -> Customer events) subscribes to these umai_bundle_* names and
     forwards them to GA4/Meta. Without it the data still goes nowhere. */
  function track(name, data) {
    var ev = 'umai_bundle_' + name, payload = data || {};
    try {
      window.dataLayer = window.dataLayer || [];
      var row = { event: ev };
      for (var k in payload) row[k] = payload[k];
      window.dataLayer.push(row);
    } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', ev, payload); } catch (e) {}
    try { if (window._learnq) window._learnq.push(['track', ev, payload]); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(ev, payload);
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent(ev, { detail: payload })); } catch (e) {}
  }

  function init(top) {
    var cfgEl = top.querySelector('[data-ubn-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg.tiers || cfg.tiers.length < 2 || !cfg.variants) return;

    var pdp = top.closest('[data-umai-pdp]') || document;
    var foot = pdp.querySelector('[data-ubn-foot]');
    if (!foot) return;

    var tiersEl = top.querySelector('[data-ubn-tiers]');
    var slotsEl = top.querySelector('[data-ubn-slots]');
    var sumEl = foot.querySelector('[data-ubn-sum]');
    var shipEl = foot.querySelector('[data-ubn-ship]');
    var ctaEl = foot.querySelector('[data-ubn-cta]');
    var errEl = foot.querySelector('[data-ubn-err]');

    /* The stock buy button and the mobile sticky bar both add ONE at full
       price — a different and more expensive transaction than the one on
       screen. Both go while the ladder owns the column. */
    var nativeRow = pdp.querySelector('.up-ctarow');
    if (nativeRow) nativeRow.style.display = 'none';
    document.body.classList.add('umai-bundle-on');

    /* The native COLOUR chips are replaced by the slots on a multi tier — two
       colour controls on one screen, one of which silently does nothing, is
       worse than either alone. SIZE stays native: it is still one choice for
       the whole pack, and reusing the theme's own chips keeps the size guide
       link, the sold-out styling and umai-pdp.js's variant plumbing intact. */
    var groups = [].slice.call(pdp.querySelectorAll('.up-chips[data-option-group]'));
    var colourGroup = null, sizeGroup = null;
    groups.forEach(function (g) {
      var n = (g.dataset.name || '').toLowerCase();
      if (n.indexOf('colour') > -1 || n.indexOf('color') > -1) colourGroup = g;
      if (n.indexOf('size') > -1) sizeGroup = g;
    });
    function labelFor(g) { return g && g.previousElementSibling && g.previousElementSibling.classList.contains('up-optlbl') ? g.previousElementSibling : null; }
    var colourLabel = labelFor(colourGroup);

    /* ---- data ---- */
    var colours = (cfg.colours || []).filter(function (c) {
      return cfg.variants.some(function (v) { return v.c === c.name && v.a; });
    });

    /* Merchandising order (cfg.order, set in the Liquid) decides which colourway
       the pack leads on and how the strip lists them. Sorted ONCE here so every
       consumer below — the fill, the grid, the strip — agrees without any of
       them knowing the rule. Unlisted colours rank last and keep Shopify's own
       order among themselves, which is why the index tiebreak is there: sort is
       only guaranteed stable in newer engines and this has to hold everywhere. */
    var pref = String(cfg.order || '').toLowerCase().split(',');
    function rank(name) {
      var n = String(name).toLowerCase();
      for (var i = 0; i < pref.length; i++) {
        var k = pref[i].replace(/^\s+|\s+$/g, '');
        if (k && n.indexOf(k) > -1) return i;
      }
      return pref.length;
    }
    colours = colours.map(function (c, i) { return { c: c, i: i, r: rank(c.name) }; })
      .sort(function (a, b) { return (a.r - b.r) || (a.i - b.i); })
      .map(function (x) { return x.c; });
    /* SHORT LABELS FOR THE GRID TILES ONLY.
       Measured in a real 360px viewport: a 6-up tile gives the caption a 39px
       box, and "CLASSIC" alone needs 41.7px at 9.5px bold — so "Classic Black"
       broke MID-WORD on most Android phones, and cleared 375 by 0.3px, which is
       luck rather than fit. Shrinking the type far enough to fit 320 lands at
       7.5px, which is not a label any more.

       So the tile drops the qualifier and keeps the word that carries the
       information: BLACK / WHITE / GRAY, one line at every width. The colour
       STRIP and the aria-labels keep the real product name — the strip is where
       the choice is made and has 100px chips to say it in, while the grid is a
       readout of what is in the pack.

       Guarded on collision: if two colourways share a last word ("Off White"
       and "Lucent White"), shortening would make them indistinguishable, so
       every tile falls back to the full name and the CSS wraps as before. */
    var shortOf = (function () {
      var map = {}, seen = {}, collide = false;
      colours.forEach(function (c) {
        var s = String(c.name).replace(/^.*\s/, '') || c.name;
        var k = s.toLowerCase();
        if (seen[k]) collide = true;
        seen[k] = true;
        map[c.name] = s;
      });
      if (collide) colours.forEach(function (c) { map[c.name] = c.name; });
      return map;
    })();

    function variantFor(c, z) {
      for (var i = 0; i < cfg.variants.length; i++) {
        if (cfg.variants[i].c === c && cfg.variants[i].z === z) return cfg.variants[i];
      }
      return null;
    }
    function inStock(c, z) { var v = variantFor(c, z); return !!(v && v.a); }

    var tierIdx = 0;
    cfg.tiers.forEach(function (t, i) { if (t.preselect) tierIdx = i; });
    function qty() { return cfg.tiers[tierIdx].qty; }
    function unit() { return cfg.unit; }
    function total(t) { return t.qty <= 1 ? unit() : t.price; }

    var slots = [];        /* the rendered pack — derived, never the source of truth */
    /* The shopper's explicit picks, by slot index. Deliberately SEPARATE from
       `slots` and never written by fill(). A first pass tracked this as a
       boolean "touched" flag and read the choice back out of `slots`, which
       broke twice: dropping to the 3-pack truncated the array so slot 6's
       colour was gone on the way back, and a size change that killed a colour
       wrote the replacement into `slots` where the stale flag then preserved
       it as if the shopper had asked for it. Storing the pick itself means the
       two can never disagree. */
    var chosen = {};
    var activeSlot = -1;   /* which slot's colour strip is open */
    var size = null;

    /* the size the native chips currently have selected */
    function readSize() {
      if (!sizeGroup) return null;
      var on = sizeGroup.querySelector('[aria-pressed="true"]');
      return on ? on.dataset.value : null;
    }

    /* The pack arrives complete and evenly split: a 3-pack opens black / white /
       grey, a 6-pack opens 2 black, 2 white, 2 grey. This is the whole reason
       the builder does not feel like work.

       GROUPED, not rotated. `floor(i * k / n)` walks the colour list once, so
       equal colours land next to each other and six tiles read as "two of each"
       at a glance instead of a repeating pattern you have to count. It also
       degrades correctly on its own: 4 slots over 3 colours gives 2/1/1, and 6
       slots over 2 in-stock colours gives 3/3, with no remainder special case.

       Only slots the shopper has NOT picked are regenerated. An explicit pick
       survives a tier change and a size change (unless that colour has no stock
       in the new size, where it is replaced for this render but not forgotten —
       go back to a size that has it and it returns). Everything else always
       comes back from the ideal split, which is what makes 6 -> 3 land on
       black/white/grey rather than keeping the first three tiles of the 6-pack. */
    function fill(n) {
      var pool = colours.filter(function (c) { return !size || inStock(c.name, size); });
      if (!pool.length) pool = colours;
      if (!pool.length) return [];   /* nothing sellable — add() reports it */
      var out = [];
      for (var i = 0; i < n; i++) {
        var want = chosen[i];
        out.push((want && pool.some(function (c) { return c.name === want; }))
          ? want
          : pool[Math.floor(i * pool.length / n)].name);
      }
      return out;
    }

    /* ---------------- tier ladder ---------------- */
    function renderTiers() {
      tiersEl.innerHTML = '';
      cfg.tiers.forEach(function (t, i) {
        var tot = total(t), was = unit() * t.qty, save = t.qty > 1 ? (was - tot) : 0;
        /* FLOOR, never round. $104.99 over six is $17.498 and rounding prints
           "$17.50 each" under a $104.99 headline — a per-shirt price the pack
           does not work out to. Flooring can only ever understate. */
        var per = Math.floor(tot / t.qty);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ubn-tier';
        b.setAttribute('aria-pressed', String(i === tierIdx));
        b.innerHTML =
          '<span class="ubn-rad" aria-hidden="true"></span>' +
          '<span class="ubn-mid">' +
            '<span class="ubn-name"><span class="ubn-nm">' +
              (t.qty > 1 ? trf('bundle_n_pack', '[n]-Pack', { n: t.qty }) : tr('bundle_single', '1 Shirt')) +
            '</span>' +
              (t.badge ? '<span class="ubn-flag">' + esc(t.badge) + '</span>' : '') +
              (save > 0 ? '<span class="ubn-pct">' + trf('bundle_save', 'Save [amount]', { amount: money(save) }) + '</span>' : '') +
            '</span>' +
            '<span class="ubn-per">' + money(per) + tr('bundle_per_item', '/shirt') + '</span>' +
          '</span>' +
          '<span class="ubn-right">' +
            '<span class="ubn-tot num">' + money(tot) + '</span>' +
            (save > 0 ? '<span class="ubn-was num">' + money(was) + '</span>' : '') +
          '</span>';
        b.addEventListener('click', function (e) { e.preventDefault(); setTier(i); });
        tiersEl.appendChild(b);
      });
    }

    function setTier(i) {
      if (tierIdx !== i) track('tier', { from: qty(), to: cfg.tiers[i].qty, value: total(cfg.tiers[i]) / 100 });
      tierIdx = i;
      var multi = qty() > 1;
      document.body.classList.toggle('umai-bundle-multi', multi);
      if (colourGroup) colourGroup.style.display = multi ? 'none' : '';
      if (colourLabel) colourLabel.style.display = multi ? 'none' : '';
      activeSlot = -1;
      /* NOT wiped on the 1-shirt tier — renderSlots hides the grid without
         reading this, and keeping it means a shopper who dips into 1 Shirt and
         back does not lose the colours they picked. */
      if (multi) slots = fill(qty());
      render();
    }

    /* ---------------- the pack ----------------
       refocus: the slot index to put focus back on after the rebuild, or
       undefined on a plain render (tier change, size change, first paint) where
       focus belongs wherever the shopper already is. */
    function renderSlots(refocus) {
      if (typeof refocus !== 'number') refocus = -1;
      var hadFocus = slotsEl.contains(document.activeElement);
      if (qty() <= 1) { slotsEl.innerHTML = ''; slotsEl.hidden = true; return; }
      slotsEl.hidden = false;

      var imgOf = {};
      colours.forEach(function (c) { imgOf[c.name] = c.img; });

      /* No "6 / 6" counter. It was there in the first pass and it is the tell of
         a builder that expects to be incomplete — the pack is ALWAYS full, so a
         progress readout that can only ever read N of N is a promise of work
         that is not owed. The grid showing six shirts says it. */
      var head =
        '<div class="ubn-shead">' +
          '<span class="m">' + tr('bundle_your_pack', 'Your pack') + '</span>' +
          '<span class="hint">' + tr('bundle_tap_hint', 'tap a shirt to change its colour') + '</span>' +
        '</div>';

      /* aria-label, not the visible name alone. The tile's text is just
         "Classic Black", which read to a screen reader as six unlabelled
         colours in a row with no hint that they are positions in a pack or that
         they do anything. "Shirt 3, Classic Black" + aria-expanded says both. */
      var grid = slots.map(function (c, i) {
        var ok = !size || inStock(c, size);
        var who = trf('bundle_shirt_n', 'Shirt [n]', { n: i + 1 });
        return '<button type="button" class="ubn-slot' + (i === activeSlot ? ' on' : '') + (ok ? '' : ' oos') + '"' +
               ' data-slot="' + i + '" aria-expanded="' + (i === activeSlot) + '"' +
               ' aria-label="' + esc(who + ', ' + c) + '">' +
                 (imgOf[c] ? '<img src="' + esc(imgOf[c]) + '" alt="" decoding="async">' : '') +
                 '<span class="nm" aria-hidden="true">' + esc(shortOf[c] || c) + '</span>' +
               '</button>';
      }).join('');

      /* the colour strip appears INLINE under the grid, not in a modal: it is
         three chips, and a dialog for three chips is theatre. It carries the
         slot's name as its group label so the chips are not three loose colours
         floating after the grid — they are "Shirt 3"'s colours. */
      var strip = '';
      if (activeSlot > -1) {
        strip = '<div class="ubn-strip" role="group" aria-label="' +
                esc(trf('bundle_shirt_n', 'Shirt [n]', { n: activeSlot + 1 })) + '">' +
          colours.map(function (c) {
            var ok = !size || inStock(c.name, size);
            return '<button type="button" class="ubn-cc' + (ok ? '' : ' oos') + '"' +
                   ' data-colour="' + esc(c.name) + '"' + (ok ? '' : ' disabled') +
                   ' aria-pressed="' + (slots[activeSlot] === c.name) + '">' +
                     (c.img ? '<img src="' + esc(c.img) + '" alt="" decoding="async">' : '') +
                     '<span>' + esc(c.name) + '</span>' +
                   '</button>';
          }).join('') + '</div>';
      }

      /* ONE ROW, always — the column count IS the tier. Measured on the live
         page at 1440x900: a fixed 3-across grid made the 6-pack two rows of
         165px shirts, 405px of builder, and put Add to Bag 164px BELOW the
         fold on the default tier. One row of six is 141px and puts it back at
         759px, in view. It also reads better than it measures: six shirts on a
         single line is one object you take in at a glance, where two rows of
         three is a list you check. Capped at 6 so a future 12-pack wraps
         instead of rendering twelve 40px stamps. */
      var cols = Math.min(qty(), 6);
      slotsEl.innerHTML = head + '<div class="ubn-grid" style="--ubn-cols:' + cols + '">' + grid + '</div>' + strip;

      /* ⚠ never rebuild during a click on a control inside this element — a
         detached target breaks ancestor checks elsewhere on the page. These
         handlers re-render deliberately and stop propagation to contain it. */
      slotsEl.querySelectorAll('[data-slot]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var i = parseInt(b.dataset.slot, 10);
          activeSlot = (activeSlot === i) ? -1 : i;
          renderSlots(i);
        });
      });
      slotsEl.querySelectorAll('[data-colour]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (b.disabled || activeSlot < 0) return;
          var i = activeSlot;
          slots[i] = b.dataset.colour;
          chosen[i] = b.dataset.colour;   /* now outranks the ideal split, for good */
          track('slot', { slot: i + 1, colour: b.dataset.colour, tier: qty() });
          activeSlot = -1;
          renderSlots(i); renderSum();
        });
      });

      /* Focus follows the slot across the rebuild. Every click in here replaces
         the innerHTML, which destroys the focused button and drops focus to
         <body> — so a keyboard shopper who opened a slot, chose a colour and hit
         Tab landed back at the top of the page. Restoring by index puts them on
         the tile they just changed, which is also where the visible ring belongs.
         Guarded on :focus-visible-ish intent (only restore if focus was already
         inside this block) so a mouse click does not paint a focus ring. */
      if (refocus > -1 && hadFocus) {
        var back = slotsEl.querySelector('[data-slot="' + refocus + '"]');
        if (back) back.focus();
      }
    }

    function renderSum() {
      var t = cfg.tiers[tierIdx], tot = total(t), was = unit() * t.qty;
      sumEl.innerHTML = t.qty > 1
        ? '<span class="l">' +
            (was > tot ? '<span class="was num">' + money(was) + '</span>' : '') +
            '<span class="now num">' + money(tot) + '</span>' +
          '</span>' +
          '<span class="per num">' + money(Math.floor(tot / t.qty)) + tr('bundle_per_item', '/shirt') + '</span>'
        : '';
      if (shipEl) {
        var show = !!cfg.ship && t.qty > 1;
        shipEl.hidden = !show;
        if (show) shipEl.innerHTML = '<span class="tick" aria-hidden="true">&#10003;</span><span>' + esc(cfg.ship) + '</span>';
      }
      ctaEl.disabled = false;
      ctaEl.textContent = size
        ? trf('bundle_add_bag', 'Add to Bag — [amount]', { amount: money(tot) })
        : tr('bundle_need_size', 'Choose a size');
    }

    function render() { renderTiers(); renderSlots(); renderSum(); }

    /* ---------------- add ---------------- */
    var adding = false;
    function add() {
      errEl.textContent = '';
      var hintEl = pdp.querySelector('[data-hint]');
      if (!size) {
        if (hintEl) { hintEl.hidden = false; try { hintEl.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {} }
        track('needs_size', { tier: qty() });
        return;
      }
      if (hintEl) hintEl.hidden = true;
      if (adding) return;

      var t = cfg.tiers[tierIdx], items = [], byId = {}, order = [];
      if (t.qty <= 1) {
        var one = pdp.querySelector('[data-variant-id]');
        var id = one && parseInt(one.value, 10);
        if (!id) return;
        items = [{ id: id, quantity: 1 }];
      } else {
        /* Collapse duplicate colours into one line with a quantity — six shirts
           as six separate 1-quantity lines is what makes a pack look like a
           mistake in the cart drawer and on the packing slip. */
        for (var i = 0; i < t.qty; i++) {
          var v = variantFor(slots[i], size);
          if (!v || !v.a) { errEl.textContent = tr('bundle_gone', 'One of those colours just sold out in this size.'); return; }
          if (!byId[v.id]) { byId[v.id] = 0; order.push(v.id); }
          byId[v.id]++;
        }
        items = order.map(function (id) { return { id: id, quantity: byId[id] }; });
      }

      adding = true;
      var label = ctaEl.textContent;
      ctaEl.disabled = true;
      ctaEl.textContent = tr('bundle_adding', 'Adding…');
      fetch(((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.text().then(function (tx) {
          var m = ''; try { var j = JSON.parse(tx); m = (j && typeof j.description === 'string') ? j.description : ''; } catch (e) {}
          throw new Error(m || tr('pdp_add_error', 'Could not add to bag — please try again.'));
        }, function () { throw new Error(tr('pdp_add_error', 'Could not add to bag — please try again.')); });
        track('add_to_cart', { tier: t.qty, size: size, colours: slots.slice(0, t.qty).join(','), lines: items.length, value: total(t) / 100 });
        ctaEl.textContent = '✓ ' + tr('bundle_added', 'Added');
        adding = false;
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(renderSum, 1400);
      }).catch(function (err) {
        ctaEl.textContent = label; ctaEl.disabled = false; adding = false;
        errEl.textContent = (err && err.message && err.message.length < 200) ? err.message : tr('pdp_add_error', 'Could not add to bag — please try again.');
      });
    }
    ctaEl.addEventListener('click', function (e) { e.preventDefault(); add(); });

    /* size lives on the theme's own chips; re-read after any chip click and
       re-check the slots, since a size can be sold out in one colour */
    pdp.addEventListener('click', function (e) {
      if (!e.target.closest('.up-chips [data-value]')) return;
      setTimeout(function () {
        var next = readSize();
        if (next === size) return;
        size = next;
        if (qty() > 1) slots = fill(qty());
        renderSlots(); renderSum();
      }, 0);
    });

    size = readSize();
    setTier(tierIdx);
    track('view', { tier: qty(), price: total(cfg.tiers[tierIdx]) });
  }

  function boot() { document.querySelectorAll('[data-ubn-top]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
